import { render, staticRenderFns } from "./CoachesSection.vue?vue&type=template&id=0010f66e&scoped=true&"
import script from "./CoachesSection.vue?vue&type=script&lang=ts&"
export * from "./CoachesSection.vue?vue&type=script&lang=ts&"
import style0 from "./CoachesSection.vue?vue&type=style&index=0&id=0010f66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010f66e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default,FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default})
